interface BasicInfoSectionProps {
  icon: React.ReactNode
  children: React.ReactNode
}

export const BasicInfo = ({ icon, children }: BasicInfoSectionProps) => {
  return (
    <div className="basic-info">
      {icon}
      {children}
    </div>
  )
}
